module.exports = __webpack_public_path__ + "static/media/ascg.9cd9923f.png";